const reactScrollOptions = {
  spy: true,
  smooth: true,
  duration: 500,
};

export { reactScrollOptions };
